import React, { useEffect, useState } from "react"

import Seo from "../../components/seo"
import CustomCompanyInfo from "../../components/CustomCompanyInfo/CustomCompanyInfo"
import "./AboutUs.scss"
import {
  LeftSide,
  CenterTop,
  CenterBottom,
  RightSide,
  LeftAlign,
  CenterALign,
  RightAlign,
  FeaturedVideo,
} from "../../components/Brand/SectionsTemplate"
import Markdown from "markdown-to-jsx"

const NewAboutPages = ({ pageContext }) => {
  const { aboutUsDetails, aboutUsId } = pageContext
  const aboutUs = aboutUsDetails.filter(item => item.id == aboutUsId)[0]

  const [title, setTitle] = useState("")
  const [subheader, setSubheader] = useState("")

  useEffect(() => {
    const sanitizeContent = async () => {
      if (typeof window === "undefined") return

      const mod = await import("dompurify")
      const createDOMPurify = mod.default || mod
      const DOMPurify = createDOMPurify(window)

      setTitle(DOMPurify.sanitize(aboutUs.title))
      setSubheader(DOMPurify.sanitize(aboutUs.sub_text))
    }

    sanitizeContent()
  }, [aboutUs])

  return (
    <CustomCompanyInfo
      pageContext={pageContext}
      pageTitle="about-us inside-pages"
      headerTitle={aboutUs.name}
      bannerImageSrc={aboutUs.banner_image}
      isAboutus={true}
    >
      <Seo
        title={aboutUs.name}
        description={aboutUs.short_description}
        lang="en"
      />
      <div className="about-us-wrapper">
        <div className="wrap">
          <Markdown
            options={{
              overrides: {
                p: {
                  component: "h2",
                  props: { className: "section-title" },
                },
              },
            }}
          >
            {title}
          </Markdown>
          <Markdown
            options={{
              overrides: {
                p: {
                  component: "article",
                },
              },
            }}
          >
            {subheader}
          </Markdown>
        </div>

        {aboutUs.sections
          .sort((a, b) => a.order - b.order)
          .map(sectionItem => {
            const type = sectionItem.section_type.name.toUpperCase()

            if (sectionItem.section_status === "ENABLED") {
              switch (type) {
                case "LEFT_SIDE":
                  return <LeftSide details={sectionItem} />

                case "CENTER_TOP":
                  return <CenterTop details={sectionItem} />

                case "CENTER_BOTTOM":
                  return <CenterBottom details={sectionItem} />

                case "RIGHT_SIDE":
                  return <RightSide details={sectionItem} />

                case "LEFT_ALIGN":
                  return <LeftAlign details={sectionItem} />

                case "CENTER_ALIGN":
                  return <CenterALign details={sectionItem} />

                case "RIGHT_ALIGN":
                  return <RightAlign details={sectionItem} />

                case "FEATURED_VIDEO":
                  return <FeaturedVideo details={sectionItem} />
              }
            }
          })}
      </div>
    </CustomCompanyInfo>
  )
}

export default NewAboutPages
